// extracted by mini-css-extract-plugin
export default {"container":"studentDataView_container__v4HYR","btns-group":"studentDataView_btns-group__kYKhr"};